/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { AiChat } from '@/components/AiChat';
import { PageHeader } from '@/components/ui';

export function AssistantPage() {
  return (<><PageHeader title="ИИ-ассистент" subtitle="Ctrl+Enter - отправить. Для вопросов по конкретному делу откройте вкладку «ИИ» в карточке дела." /><AiChat /></>);
}
